import {Injectable} from '@angular/core';
import {BaseService} from "../../../services/base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "../../../services/auth.service";
import {ProductService} from "./product.service";


@Injectable({
    providedIn: 'root'
})
export class PaymentService extends BaseService {


    lastOrderId = null;

    constructor(private httpClient: HttpClient,
                private authService: AuthService,
                private productsService: ProductService
    ) {
        super();
    }


    getKNETPaymentUrl(order_id) {

        let serviceURL = this.baseAPI + "adham/knet/requesturl";

        let params =
            {
                "order_id": order_id
            }

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
    }

    loadBankPaymentRestrictions() {

        let serviceURL = this.baseAPI2 + "/mage/sett";
        var obj = {
            module: "payment/banktransfer"
        }
        return this.httpClient.post<any>(serviceURL, obj, this.authService.getHttpOptions());

    }

    getMastercardSession(order_id) {

        let serviceURL = this.baseAPI2 + "/mastercard/sess/request";

        let params =
            {
                "order_id": order_id,
                "amount": "100",
                "currency": "USD"
            }

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
    }

    checkMastercardPaymentResult(session_ver,success_indicator) {

        let serviceURL = this.baseAPI2 + "/mastercard/sess/check";

        let params =
            {
                "sess_ver": session_ver,
                "claimed_indicator": success_indicator
            }

        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
    }


}
